import { c as _c } from "react/compiler-runtime";
import { logger } from "@justhome/common";
import { Lead, LeadCreationAction, LeadCreationResponse, MaximumBudget, Partner, usePostLead, usePostMaximumBudget } from "@justhome/api-core";
import { getFormConsentText } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import { localeToLanguageISOCode } from "@lib/utilities";
import { getOrigin } from "@lib/utm";
import { useCallback, useEffect, useRef, useState } from "react";
import mapFormToMaximumBudget from "../lib/budgetCheck/mapFormToMaximumBudget";
import { BudgetCheckFormValues, YesNo } from "../lib/budgetCheck/types";
interface UsePostApplicationWithLeadProps {
  onSuccess: (maximumBudget: MaximumBudget, lead: LeadCreationResponse) => void;
  budgetCheckForm?: BudgetCheckFormValues;
  leadCreationAction: LeadCreationAction;
  partner?: Partner;
}
const usePostBudgetCheckWithLead = t0 => {
  const $ = _c(25);
  const {
    budgetCheckForm,
    onSuccess,
    leadCreationAction,
    partner
  } = t0;
  const locale = useLanguage();
  const [form, setForm] = useState();
  const saveLeadAfterApplication = useRef(false);
  const maximumBudgetRef = useRef(undefined);
  let t1;
  if ($[0] !== onSuccess) {
    t1 = {
      onSuccess(lead) {
        onSuccess(maximumBudgetRef.current, lead);
      },
      onError(error) {
        logger.error("Error while posting a lead.", error);
      }
    };
    $[0] = onSuccess;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isLoading: isLeadLoading,
    isError: isLeadError,
    mutate: postLead
  } = usePostLead(t1);
  let t2;
  if ($[2] !== budgetCheckForm?.wantsToSellAProperty || $[3] !== leadCreationAction || $[4] !== locale || $[5] !== partner || $[6] !== postLead) {
    t2 = async (leadForm, maximumBudgetId) => {
      const utmOrigin = getOrigin();
      const origin = utmOrigin ? [utmOrigin] : [];
      const consentText = getFormConsentText({
        locale,
        partner
      });
      const body = {
        email: leadForm.email,
        firstName: leadForm.firstName,
        lastName: leadForm.lastName,
        phone: leadForm.phone,
        language: localeToLanguageISOCode(locale),
        maximumBudgetId,
        origin,
        partnerId: partner?.id,
        action: leadCreationAction,
        wantsToSellAProperty: budgetCheckForm?.wantsToSellAProperty === YesNo.yes ? "YES" : "NO",
        consentText
      };
      postLead({
        body
      });
    };
    $[2] = budgetCheckForm?.wantsToSellAProperty;
    $[3] = leadCreationAction;
    $[4] = locale;
    $[5] = partner;
    $[6] = postLead;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const saveLead = t2;
  let t3;
  if ($[8] !== form || $[9] !== saveLead) {
    t3 = {
      onError(error_0, variables) {
        logger.error("Error while posting maximum budget.", error_0, variables);
      },
      onSuccess: application => {
        maximumBudgetRef.current = application;
        if (saveLeadAfterApplication.current) {
          saveLead(form, maximumBudgetRef.current.id);
        }
      }
    };
    $[8] = form;
    $[9] = saveLead;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    mutate: postMaximumBudget,
    isLoading: isApplicationLoading,
    isError: isApplicationError
  } = usePostMaximumBudget(t3);
  let t4;
  if ($[11] !== budgetCheckForm || $[12] !== partner?.id || $[13] !== postMaximumBudget) {
    t4 = () => {
      if (!budgetCheckForm) {
        return;
      }
      const body_0 = mapFormToMaximumBudget(budgetCheckForm, budgetCheckForm.leadId, partner?.id);
      postMaximumBudget({
        body: body_0
      });
    };
    $[11] = budgetCheckForm;
    $[12] = partner?.id;
    $[13] = postMaximumBudget;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== budgetCheckForm || $[16] !== partner || $[17] !== postMaximumBudget) {
    t5 = [postMaximumBudget, budgetCheckForm, partner];
    $[15] = budgetCheckForm;
    $[16] = partner;
    $[17] = postMaximumBudget;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  useEffect(t4, t5);
  let t6;
  if ($[19] !== saveLead) {
    t6 = async form_0 => {
      setForm(form_0);
      if (maximumBudgetRef.current) {
        saveLead(form_0, maximumBudgetRef.current.id);
      } else {
        saveLeadAfterApplication.current = true;
      }
    };
    $[19] = saveLead;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const handleSubmit = t6;
  const t7 = form && isApplicationLoading || isLeadLoading;
  const t8 = form && isApplicationError || isLeadError;
  let t9;
  if ($[21] !== handleSubmit || $[22] !== t7 || $[23] !== t8) {
    t9 = {
      isLoading: t7,
      handleSubmit,
      isError: t8
    };
    $[21] = handleSubmit;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export default usePostBudgetCheckWithLead;